module.exports = __webpack_public_path__ + "img/slide-images-04.1f8fcad3.jpg";